module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 detalj 2023 4.de7dcbe4.jpg";